<template>
  <li class="border-b border-b-[#B8BCC3]">
    <Collapsible
      v-if="benefit.text"
      additional-classes="py-3 text-base"
      :title="benefit.title"
      :icon="iconSrc"
    >
      <RichTextRenderer :document="benefit.text"></RichTextRenderer>
    </Collapsible>
    <div
      v-else
      class="flex w-full items-center gap-x-2 py-3 text-left text-base"
    >
      <FimPicture
        v-if="iconSrc"
        provider="storyblok"
        :src="iconSrc"
        :alt="iconAlt || benefit.title"
        width="24"
        height="24"
        class="size-6 shrink-0 object-contain"
        loading="lazy"
      />
      <span class="grow">{{ benefit.title }}</span>
    </div>
  </li>
</template>

<script setup lang="ts">
import type { SbBenefitsItem } from '~/storyblok/types/storyblok.gen'

const props = defineProps({
  benefit: {
    type: Object as PropType<SbBenefitsItem>,
    required: true,
  },
})

const iconSrc = computed(() => getAssetValue(props.benefit.icon)?.filename)
const iconAlt = computed(() => getAssetValue(props.benefit.icon)?.alt)
</script>
